import { codeableConcept } from '#src/codeableConcept.ts'
import {
  COMMUNICATION_CATEGORY,
  COMMUNICATION_MEDIUM_SYSTEM,
} from '#src/codeSystems.ts'

export const COMMUNICATION_CATEGORIES = {
  note: codeableConcept({
    system: COMMUNICATION_CATEGORY,
    code: 'communication-note',
    display: 'Note',
  }),
  comment: codeableConcept({
    system: COMMUNICATION_CATEGORY,
    code: 'communication-comment',
    display: 'Comment',
  }),
  sdrNotification: codeableConcept({
    system: COMMUNICATION_CATEGORY,
    code: 'communication-sdr-notification',
    display: 'SDR Notification',
  }),
  phoneCall: codeableConcept({
    system: COMMUNICATION_CATEGORY,
    code: 'communication-phone-call',
    display: 'Phone Call',
  }),
  aiThread: codeableConcept({
    system: COMMUNICATION_CATEGORY,
    code: 'ai-thread',
    display: 'AI Thread',
  }),
  orderRevokeReason: codeableConcept({
    system: COMMUNICATION_CATEGORY,
    code: 'order-revoke-reason',
    display: 'Order Revoke Reason',
  }),
}

// https://terminology.hl7.org/6.1.0/CodeSystem-v3-ParticipationMode.html
export const CommunicationMedium = {
  // Level 1 - Main categories
  // ELECTRONIC = 'ELECTRONIC', // Participation by non-human-languaged based electronic signal
  // PHYSICAL = 'PHYSICAL', // Participation by direct action where subject and actor are in the same location
  // REMOTE = 'REMOTE', // Participation by direct action where subject and actor are in separate locations
  VERBAL: 'VERBAL', // Participation by voice communication
  WRITTEN: 'WRITTEN',
} as const
export type CommunicationMedium =
  (typeof CommunicationMedium)[keyof typeof CommunicationMedium]

export const ParticipationModeSubType = {
  // // Level 2 - Verbal category and subtypes
  // DICTATE = 'DICTATE', // Participation by pre-recorded voice
  // FACE_TO_FACE = 'FACE', // Participation by voice communication where parties speak to each other directly
  TELEPHONE: 'PHONE', // Participation by voice communication over electronic medium
  // VIDEO_CONFERENCING = 'VIDEOCONF', // Participation by voice and visual communication over electronic medium

  // // Level 2 - Written category and subtypes
  FAX: 'FAXWRIT', // Participation by text/diagrams transmitted over fax
  // HANDWRITTEN = 'HANDWRIT', // Participation by text/diagrams on paper or other medium
  // MAIL = 'MAILWRIT', // Participation by text/diagrams transmitted physically
  // TYPEWRITTEN = 'TYPEWRIT', // Participation by text/diagrams using typewriter, computer, etc.

  // ONLINE = 'ONLINEWRIT', // Participation by text/diagrams submitted by computer network
  // // Level 3 - Messaging category and subtypes
  EMAIL: 'EMAILWRIT',
} as const
export type ParticipationModeSubType =
  (typeof ParticipationModeSubType)[keyof typeof ParticipationModeSubType]

export const COMMUNICATION_MEDIUMS = {
  // Main categories
  // [ParticipationMode.ELECTRONIC]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationMode.ELECTRONIC,
  //   display: 'electronic data',
  // }),
  // [ParticipationMode.PHYSICAL]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationMode.PHYSICAL,
  //   display: 'physical presence',
  // }),
  // [ParticipationMode.REMOTE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationMode.REMOTE,
  //   display: 'remote presence',
  // }),
  [CommunicationMedium.VERBAL]: codeableConcept({
    system: COMMUNICATION_MEDIUM_SYSTEM,
    code: CommunicationMedium.VERBAL,
    display: 'verbal',
  }),
  [CommunicationMedium.WRITTEN]: codeableConcept({
    system: COMMUNICATION_MEDIUM_SYSTEM,
    code: CommunicationMedium.WRITTEN,
    display: 'written',
  }),

  // Verbal modes
  // [ParticipationModeSubType.DICTATE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.DICTATE,
  //   display: 'dictated',
  // }),
  // [ParticipationModeSubType.FACE_TO_FACE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.FACE_TO_FACE,
  //   display: 'face-to-face',
  // }),
  [ParticipationModeSubType.TELEPHONE]: codeableConcept({
    system: COMMUNICATION_MEDIUM_SYSTEM,
    code: ParticipationModeSubType.TELEPHONE,
    display: 'telephone',
  }),
  // [ParticipationModeSubType.VIDEO_CONFERENCING]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.VIDEO_CONFERENCING,
  //   display: 'video conference',
  // }),

  // Written modes
  [ParticipationModeSubType.FAX]: codeableConcept({
    system: COMMUNICATION_MEDIUM_SYSTEM,
    code: ParticipationModeSubType.FAX,
    display: 'telefax',
  }),
  // [ParticipationModeSubType.HANDWRITTEN]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.HANDWRITTEN,
  //   display: 'handwritten',
  // }),
  // [ParticipationModeSubType.MAIL]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.MAIL,
  //   display: 'mail',
  // }),
  // [ParticipationModeSubType.TYPEWRITTEN]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.TYPEWRITTEN,
  //   display: 'typewritten',
  // }),
  // [ParticipationModeSubType.ONLINE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.ONLINE,
  //   display: 'online written',
  // }),
  // [ParticipationModeSubType.EMAIL]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.EMAIL,
  //   display: 'email',
  // }),

  // Messaging modes
  // [ParticipationModeSubType.MESSAGING]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.MESSAGING,
  //   display: 'messaging',
  // }),
  // [ParticipationModeSubType.SMS_MESSAGE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.SMS_MESSAGE,
  //   display: 'SMS message',
  // }),
  // [ParticipationModeSubType.MMS_MESSAGE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.MMS_MESSAGE,
  //   display: 'MMS message',
  // }),
  // [ParticipationModeSubType.APP_MESSAGE]: codeableConcept({
  //   system: COMMUNICATION_MEDIUM_SYSTEM,
  //   code: ParticipationModeSubType.APP_MESSAGE,
  //   display: 'messaging app',
  // }),
}
